(function (angular) {
  "use strict";

  angular.module('myApp').factory('aimSave', [
    "$window",
    function ($window) {

      var aimSave = function () {

        this.serviceMethod = null;

        //this.recaptchaEnable = recaptchaEnable;
        //this.requireCaptcha = false;

        // login page hack
        this.returnUrl = null;

        this.result = {};
        this.dto = {};

        //callback function
        this.onAfterSave = null;
      };

      aimSave.prototype.save = function () {
        //dataNeedSaving = false;
        var $that = this;

        //var dto = clone(this.dto);
        //DotObject.object(dto);

        this.serviceMethod(this.dto)
          .then(function (resp) {

            $that.result = resp.data;

            if (resp.data.success) {

              if (resp.data.clearForm) {
                $that.dto = {};
                //setTimeout(function () {
                //  funResetInputPlaceholder();
                //}, 300);
              }

              if (typeof $that.onAfterSave === "function") {
                $that.onAfterSave();
              }

              if (resp.data.redirect) {
                if ($that.returnUrl != null || $that.returnUrl != undefined) {
                  window.location.href = $that.returnUrl;
                } else {
                  window.location.href = resp.data.redirect;
                }
              }
            }
            //else {
            //  dataNeedSaving = true;
            //}

            //if ($that.recaptchaEnable && $that.requireCaptcha)
            //  $that.cbExpiration();

            //$window.scrollTo(0, 0);
          });
      };

      //aimSave.prototype.setResponse = function (response) {
      //  this.dto.googleRecaptchaResponse = response;
      //  this.save();
      //};

      //aimSave.prototype.setWidgetId = function (widgetId) {
      //  this.widgetId = widgetId;
      //};

      //aimSave.prototype.cbExpiration = function () {
      //  vcRecaptchaService.reload(this.widgetId);
      //  this.dto.googleRecaptchaResponse = null;
      //};

      return aimSave;
    }
  ]);

}(window.angular));
